import { Grid } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';
import PatientProjectContainer from './PatientProjectContainer';
import PatientScanContainer from './PatientScanContainer';
interface PatientContainer {
  className?: string;
}

function PatientContainer({ className }: PatientContainer) {
  return (
    <StyledPatient data-component-name="Patient" item className={className}>
      <PatientScanContainer />
      <PatientProjectContainer />
    </StyledPatient>
  );
}

const StyledPatient = styled(Grid)`
  width: 810px;
  display: flex;
  column-gap: 20px;
`;

export default React.memo(PatientContainer);
